/**
 * @format
 */
import { SELECT_UNSELECT_DEAL } from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case SELECT_UNSELECT_DEAL: {
      const { dealId, checked, shouldClearAll } = payload;

      // If shouldClearAll is true, clear the entire selectedDealsMap
      if (shouldClearAll) {
        return {
          ...state,
          selectedDealsMap: {},
        };
      }

      if (state.selectedDealsMap[dealId] === checked) {
        // Create new object only when value changes
        return state; // No change needed, return same state
      }

      // Only create new object when actually changing
      const selectedDealsMap = { ...state.selectedDealsMap };
      selectedDealsMap[dealId] = checked;

      return {
        ...state,
        selectedDealsMap,
      };
    }
    default:
      return state;
  }
};
